<script setup lang="ts">
import { computed, toRefs } from 'vue';

import { useYardAreaPresenter } from '@satellite/composables/useYardAreaPresenter';

import type { Maybe } from '@nova/core';
import type { YardAreaDetails } from '@satellite/composables/useYardAreaPresenter';

const props = withDefaults(
  defineProps<{
    size?: 'regular' | 'small';
    area?: Maybe<YardAreaDetails>;
    areaId?: Maybe<string>;
  }>(),
  {
    size: 'regular',
    area: null,
    areaId: null
  }
);

const { areaId, area } = toRefs(props);

const {
  data: areaPresenter,
  isLoading,
  onIntersect
} = useYardAreaPresenter({
  areaId,
  placeholderAreaData: area,
  mode: 'live'
});

const areaName = computed(() => areaPresenter.value?.name ?? null);
</script>

<template>
  <v-skeleton-loader
    :loading="isLoading"
    type="text"
    v-intersect="{
      handler: onIntersect,
      options: {
        threshold: [0.5]
      }
    }">
    <div class="d-flex flex-column gap-1 yard-area-presenter" style="min-width: 50px">
      <span
        :class="size === 'small' ? 'typography-body-sm' : 'typography-body-md'"
        data-testid="yard-area-presenter-area-name">
        {{ areaName || '-' }}
      </span>
    </div>
  </v-skeleton-loader>
</template>

<style scoped>
:deep(.v-skeleton-loader__text) {
  /** this value makes the loader have the same vertical spacing as the area name text */
  margin: 6px 0 !important;
}
</style>
